export default __webpack_public_path__ + "static/media/vectorIco.5882f131.svg";